import { memo } from 'react'
import Box from '@mui/material/Box'

import { Image } from '../shared/image'

const SummaryIcon = ({ sx, icon, width = 120, imgWidth = 146 }) => {
  return (
    <Box
      sx={{
        width,
        height: width,
        lineHeight: 0,
        borderRadius: '50%',
        bgcolor: 'background.neutral',
        overflow: 'visible',
        position: 'relative',
        ...sx
      }}
    >
      <Image
        src={icon}
        sx={{
          position: 'absolute',
          top: '-15px',
          left: '-5px',
          width: imgWidth,
          height: imgWidth
        }}
      />
    </Box>
  )
}

export default memo(SummaryIcon)
